import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../auth";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Copy } from "lucide-react";
import { PortalHeader } from "../components/PortalHeader";

export default function TemplatesPage() {
  const { API, authHeaders } = useAuth();
  const nav = useNavigate();
  const [templates, setTemplates] = useState([]);

  const load = () => axios.get(`${API}/admin/templates`, { headers: authHeaders }).then((r) => setTemplates(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id, name) => {
    if (!confirm(`Delete template "${name}"?`)) return;
    await axios.delete(`${API}/admin/templates/${id}`, { headers: authHeaders });
    toast.success("Deleted");
    load();
  };

  return (
    <div className="min-h-screen" data-testid="templates-page">
      <PortalHeader eyebrow="Templates" backTo="/admin" />
      <div className="px-6 py-10 max-w-4xl mx-auto">
      <div className="flex justify-between items-end">
        <h1 className="font-display text-4xl">Trip templates</h1>
        <button data-testid="use-template-btn" onClick={() => nav("/admin/trips/new")} className="tcm-btn-primary inline-flex items-center gap-2">
          <Copy size={12} /> New trip from template
        </button>
      </div>
      <p className="text-sm text-[color:var(--tcm-navy-70)] mt-3 max-w-xl">
        Save any trip's itinerary, budget lines, logistics and recs as a reusable blueprint. Clone it in one click for the next Amalfi, Kyoto or Marrakech client — dates, client-specific data and payment status all reset automatically.
      </p>
      <hr className="tcm-gold-rule my-6" />

      {templates.length === 0 && (
        <div className="tcm-double-frame">
          <div className="tcm-inner p-10 text-center">
            <p className="font-display text-2xl">No templates yet</p>
            <p className="text-sm text-[color:var(--tcm-navy-70)] mt-3">
              Open any trip in the admin editor and tap <em>Save as template</em>.
            </p>
          </div>
        </div>
      )}

      <div className="space-y-4">
        {templates.map((t) => (
          <div key={t.id} data-testid={`tpl-row-${t.id}`} className="tcm-double-frame">
            <div className="tcm-inner p-5 flex justify-between items-start gap-4">
              <div>
                <p className="tcm-eyebrow">
                  Built from {t.source_destination} · by {t.created_by_name} · {new Date(t.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                </p>
                <p className="font-display text-2xl mt-1">{t.name}</p>
                {t.description && <p className="text-sm text-[color:var(--tcm-navy-70)] mt-1">{t.description}</p>}
                <p className="text-[11px] mt-3" style={{ color: "var(--tcm-gold-700)" }}>
                  {t.counts?.itinerary || 0} itinerary · {t.counts?.reservations || 0} reservations · {t.counts?.budget_lines || 0} budget lines · {t.counts?.logistics || 0} logistics · {t.counts?.recommendations || 0} recs
                </p>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <button data-testid={`clone-${t.id}`} onClick={() => nav("/admin/trips/new")}
                        className="tcm-btn-primary inline-flex items-center gap-1.5 text-[11px] py-2 px-3">
                  <Copy size={12} /> Use
                </button>
                <button data-testid={`del-tpl-${t.id}`} onClick={() => del(t.id, t.name)}
                        className="tcm-btn-outline inline-flex items-center gap-1.5 text-[11px] py-2 px-3">
                  <Trash2 size={12} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}
